<template>
  <div>
    <div class="GeZai_Layer relative">
      <img :src="layer1" :class="$store.getters.hOrV + ' h350'" alt="" />

      <div class="hold-img" :class="$store.getters.hOrV">
        <img
          :src="($store.getters.isVertical) ? 'images/collection/display/rm1_top.png' : 'images/collection/display/rm1.png'"
          v-if="$store.state.artwork.layout == 'M1'" class="h350" alt="" />
        <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        <template v-if="$store.getters.isDouble">
          <img
            :src="($store.getters.isVertical) ? 'images/collection/display/rm1_bottom.png' : 'images/collection/display/rm1_no_glare.png'"
            v-if="$store.state.artwork.rightLayout == 'M1'" class="h350" alt="" />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
      </div>
      <div class="button-img" :class="$store.getters.hOrV">
        <img src="images/collection/sockets/socket_placeholder.png" v-if="$store.state.artwork.layout == 'SK'"
          class="h350" alt="" />
        <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        <template v-if="$store.state.artwork.format != 'single'">
          <img src="images/collection/sockets/socket_placeholder.png" v-if="$store.state.artwork.rightLayout == 'SK'"
            class="h350" alt="" />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
        <template v-if="$store.getters.isTriple">
          <img src="images/collection/sockets/socket_placeholder.png"
            v-if="$store.state.artwork.tripleRightLayout == 'SK'" class="h350" alt="" />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
      </div>

      <div class="body-img" :class="$store.getters.hOrV">
        <div class="table2" :class="{
          two: $store.state.artwork.format == 'double',
          vtwo: $store.state.artwork.format == 'vdouble',
          three: $store.state.artwork.format == 'triple',
          vthree: $store.state.artwork.format == 'vtriple'
        }">
          <div class="layer2" v-for="(i, index) in layer2" :key="index" :style="{
            top: i.top + 'mm',
            left: i.left + 'mm',
            width: i.width + 'mm',
            height: i.height + 'mm',
          }">
            <div :style="{
              verticalAlign: i.style.alignment,
              color: i.content.color,
            }">
              <i v-if="
                i.style.constrain == 1 ||
                i.style.constrain == 4 ||
                i.style.constrain == 5
              " :class="i.content.icon" class="iconfont2"
                :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"></i>
              <p v-if="
                i.style.constrain == 2 ||
                i.style.constrain == 3 ||
                i.style.constrain == 4 ||
                i.style.constrain == 5
              " class=" "
                :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px', marginTop: offset(i) + 'px' }">
                {{ i.content.textL1 }}</p>
              <p v-if="i.style.constrain == 3 || i.style.constrain == 5" class=" "
                :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px' }">
                {{ i.content.textL2 }}</p>
            </div>
          </div>

          <div v-if="$store.state.artwork.format != 'single'">
            <div class="layer2 right-side" v-for="(i, index) in rightLayer2" :key="'right' + index" :style="{
              top: i.top + 'mm',
              left: i.left + 'mm',
              width: i.width + 'mm',
              height: i.height + 'mm',
            }">
              <div :style="{
                verticalAlign: i.style.alignment,
                color: i.content.color,
              }">
                <i v-if="
                  i.style.constrain == 1 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5
                " :class="i.content.icon" class="iconfont2" :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"></i>
                <p v-if="
                  i.style.constrain == 2 ||
                  i.style.constrain == 3 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5
                " class=" "
                  :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px', marginTop: offset(i) + 'px' }">
                  {{ i.content.textL1 }}</p>
                <p v-if="i.style.constrain == 3 || i.style.constrain == 5" class=" "
                  :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px' }">
                  {{ i.content.textL2 }}</p>
              </div>
            </div>
          </div>

          <div v-if="$store.getters.isTriple">
            <div class="layer2" v-for="(i, index) in tripleRightLayer2" :key="'right' + index" :style="{
              top: i.top + 'mm',
              left: i.left + 'mm',
              width: i.width + 'mm',
              height: i.height + 'mm',
            }">
              <div :style="{
                verticalAlign: i.style.alignment,
                color: i.content.color,
              }">
                <i v-if="
                  i.style.constrain == 1 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5
                " :class="i.content.icon" class="iconfont2" :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"></i>
                <p v-if="
                  i.style.constrain == 2 ||
                  i.style.constrain == 3 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5
                " class=" "
                  :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px', marginTop: offset(i) + 'px' }">
                  {{ i.content.textL1 }}</p>
                <p v-if="i.style.constrain == 3 || i.style.constrain == 5" class=" "
                  :style="{ fontFamily: fontType.toLowerCase().replaceAll(' ', ''), whiteSpace: 'pre', height: i.textBoxHeight, fontSize: i.fontSize + 'px' }">
                  {{ i.content.textL2 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var tripleRightLayoutMap = {
  triple: {
    L9: [
      { top: 19.5, left: 209.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 237.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 266.2, height: 14.2, width: 14.2 },
      { top: 40.7, left: 209.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 237.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 266.2, height: 14.2, width: 14.2 },
      { top: 61.9, left: 209.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 237.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 266.2, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 15.4, left: 210, height: 14.2, width: 14.2 },
      { top: 15.4, left: 237.6, height: 14.2, width: 14.2 },
      { top: 15.4, left: 265.8, height: 14.2, width: 14.2 },
      { top: 32.3, left: 210, height: 14.2, width: 14.2 },
      { top: 32.3, left: 237.6, height: 14.2, width: 14.2 },
      { top: 32.3, left: 265.8, height: 14.2, width: 14.2 },
      { top: 49.2, left: 210, height: 14.2, width: 14.2 },
      { top: 49.2, left: 237.6, height: 14.2, width: 14.2 },
      { top: 49.2, left: 265.8, height: 14.2, width: 14.2 },
      { top: 66.1, left: 210, height: 14.2, width: 14.2 },
      { top: 66.1, left: 237.6, height: 14.2, width: 14.2 },
      { top: 66.1, left: 265.8, height: 14.2, width: 14.2 },
    ],
    SK: []
  },
  vtriple: {
    L9: [
      { top: 217.1, left: 12.1, height: 14.2, width: 14.2 },
      { top: 217.1, left: 40.1, height: 14.2, width: 14.2 },
      { top: 217.1, left: 68.7, height: 14.2, width: 14.2 },
      { top: 238.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 238.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 238.3, left: 68.7, height: 14.2, width: 14.2 },
      { top: 259.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 259.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 259.5, left: 68.7, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 212.7, left: 12.5, height: 14.2, width: 14.2 },
      { top: 212.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 212.7, left: 68.3, height: 14.2, width: 14.2 },
      { top: 229.6, left: 12.5, height: 14.2, width: 14.2 },
      { top: 229.6, left: 40.1, height: 14.2, width: 14.2 },
      { top: 229.6, left: 68.3, height: 14.2, width: 14.2 },
      { top: 246.5, left: 12.5, height: 14.2, width: 14.2 },
      { top: 246.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 246.5, left: 68.3, height: 14.2, width: 14.2 },
      { top: 263.5, left: 12.5, height: 14.2, width: 14.2 },
      { top: 263.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 263.5, left: 68.3, height: 14.2, width: 14.2 },
    ],
    SK: []
  }
};
var rightLayoutMap = {
  double: {
    L9: [
      { top: 19.5, left: 110.9, height: 14.2, width: 14.2 },
      { top: 19.5, left: 138.9, height: 14.2, width: 14.2 },
      { top: 19.5, left: 167.5, height: 14.2, width: 14.2 },
      { top: 40.7, left: 110.9, height: 14.2, width: 14.2 },
      { top: 40.7, left: 138.9, height: 14.2, width: 14.2 },
      { top: 40.7, left: 167.5, height: 14.2, width: 14.2 },
      { top: 61.9, left: 110.9, height: 14.2, width: 14.2 },
      { top: 61.9, left: 138.9, height: 14.2, width: 14.2 },
      { top: 61.9, left: 167.5, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 15.4, left: 111.2, height: 14.2, width: 14.2 },
      { top: 15.4, left: 139, height: 14.2, width: 14.2 },
      { top: 15.4, left: 167, height: 14.2, width: 14.2 },
      { top: 32.3, left: 111.2, height: 14.2, width: 14.2 },
      { top: 32.3, left: 139, height: 14.2, width: 14.2 },
      { top: 32.3, left: 167, height: 14.2, width: 14.2 },
      { top: 49.2, left: 111.2, height: 14.2, width: 14.2 },
      { top: 49.2, left: 139, height: 14.2, width: 14.2 },
      { top: 49.2, left: 167, height: 14.2, width: 14.2 },
      { top: 66.1, left: 111.2, height: 14.2, width: 14.2 },
      { top: 66.1, left: 139, height: 14.2, width: 14.2 },
      { top: 66.1, left: 167, height: 14.2, width: 14.2 },
    ],
    M1: [
      { top: 45.3, left: 112, height: 12.5, width: 13.5 },
      { top: 45.3, left: 139.8, height: 12.5, width: 13.5 },
      { top: 45.3, left: 167, height: 12.5, width: 13.5 },
      { top: 66.8, left: 111.6, height: 13.5, width: 14.2 },
      { top: 66.8, left: 139.15, height: 13.5, width: 14.2 },
      { top: 66.8, left: 166.65, height: 13.5, width: 14.2 },
      //temperature icons
      { top: 21.47, left: 115.68, height: 14.2, width: 9.825 },
      { top: 21.47, left: 167, height: 14.2, width: 9.825 },
    ],
    SK: []
  },
  vdouble: {
    L9: [
      { top: 118.4, left: 12.1, height: 14.2, width: 14.2 },
      { top: 118.4, left: 40.1, height: 14.2, width: 14.2 },
      { top: 118.4, left: 68.7, height: 14.2, width: 14.2 },
      { top: 139.6, left: 12.1, height: 14.2, width: 14.2 },
      { top: 139.6, left: 40.1, height: 14.2, width: 14.2 },
      { top: 139.6, left: 68.7, height: 14.2, width: 14.2 },
      { top: 160.8, left: 12.1, height: 14.2, width: 14.2 },
      { top: 160.8, left: 40.1, height: 14.2, width: 14.2 },
      { top: 160.8, left: 68.7, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 114, left: 12.5, height: 14.2, width: 14.2 },
      { top: 114, left: 40.1, height: 14.2, width: 14.2 },
      { top: 114, left: 68.3, height: 14.2, width: 14.2 },
      { top: 130.9, left: 12.5, height: 14.2, width: 14.2 },
      { top: 130.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 130.9, left: 68.3, height: 14.2, width: 14.2 },
      { top: 147.8, left: 12.5, height: 14.2, width: 14.2 },
      { top: 147.8, left: 40.1, height: 14.2, width: 14.2 },
      { top: 147.8, left: 68.3, height: 14.2, width: 14.2 },
      { top: 164.7, left: 12.5, height: 14.2, width: 14.2 },
      { top: 164.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 164.7, left: 68.3, height: 14.2, width: 14.2 },
    ],
    M1: [
      { top: 144.1, left: 13.25, height: 12.5, width: 13.5 },
      { top: 144.1, left: 40.75, height: 12.5, width: 13.5 },
      { top: 144.1, left: 68.25, height: 12.5, width: 13.5 },
      { top: 165.57, left: 12.9, height: 13.5, width: 14.2 },
      { top: 165.57, left: 40.4, height: 13.5, width: 14.2 },
      { top: 165.57, left: 67.9, height: 13.5, width: 14.2 },
      //temperature icons
      { top: 120.2, left: 16.9, height: 14.2, width: 9.825 },
      { top: 120.2, left: 68.25, height: 14.2, width: 9.825 },
    ],
    SK: []
  },
  triple: {
    SK: []
  },
  vtriple: {
    SK: []
  }

};
var layoutMap = {
  single: {
    L9: [
      { top: 19.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 19.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 19.5, left: 68.7, height: 14.2, width: 14.2 },
      { top: 40.7, left: 12.1, height: 14.2, width: 14.2 },
      { top: 40.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 40.7, left: 68.7, height: 14.2, width: 14.2 },
      { top: 61.9, left: 12.1, height: 14.2, width: 14.2 },
      { top: 61.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 61.9, left: 68.7, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 15.4, left: 12.5, height: 14.2, width: 14.2 },
      { top: 15.4, left: 40.1, height: 14.2, width: 14.2 },
      { top: 15.4, left: 68.3, height: 14.2, width: 14.2 },
      { top: 32.3, left: 12.5, height: 14.2, width: 14.2 },
      { top: 32.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 32.3, left: 68.3, height: 14.2, width: 14.2 },
      { top: 49.2, left: 12.5, height: 14.2, width: 14.2 },
      { top: 49.2, left: 40.1, height: 14.2, width: 14.2 },
      { top: 49.2, left: 68.3, height: 14.2, width: 14.2 },
      { top: 66.1, left: 12.5, height: 14.2, width: 14.2 },
      { top: 66.1, left: 40.1, height: 14.2, width: 14.2 },
      { top: 66.1, left: 68.3, height: 14.2, width: 14.2 },
    ],
    M1: [
      { top: 45.3, left: 13.25, height: 12.5, width: 13.5 },
      { top: 45.3, left: 40.75, height: 12.5, width: 13.5 },
      { top: 45.3, left: 68.25, height: 12.5, width: 13.5 },
      { top: 66.8, left: 12.9, height: 13.5, width: 14.2 },
      { top: 66.8, left: 40.4, height: 13.5, width: 14.2 },
      { top: 66.8, left: 67.9, height: 13.5, width: 14.2 },
      //temperature icons
      { top: 21.47, left: 16.9, height: 14.2, width: 9.825 },
      { top: 21.47, left: 68.25, height: 14.2, width: 9.825 },

    ],
    SK: []
  },
  double: {
    L9: [
      { top: 19.5, left: 13.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 41.4, height: 14.2, width: 14.2 },
      { top: 19.5, left: 67, height: 14.2, width: 14.2 },
      { top: 40.7, left: 13.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 41.4, height: 14.2, width: 14.2 },
      { top: 40.7, left: 67, height: 14.2, width: 14.2 },
      { top: 61.9, left: 13.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 41.4, height: 14.2, width: 14.2 },
      { top: 61.9, left: 67, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 15.4, left: 13.75, height: 14.2, width: 14.2 },
      { top: 15.4, left: 41.3, height: 14.2, width: 14.2 },
      { top: 15.4, left: 69.5, height: 14.2, width: 14.2 },
      { top: 32.3, left: 13.75, height: 14.2, width: 14.2 },
      { top: 32.3, left: 41.3, height: 14.2, width: 14.2 },
      { top: 32.3, left: 69.5, height: 14.2, width: 14.2 },
      { top: 49.2, left: 13.75, height: 14.2, width: 14.2 },
      { top: 49.2, left: 41.3, height: 14.2, width: 14.2 },
      { top: 49.2, left: 69.5, height: 14.2, width: 14.2 },
      { top: 66.1, left: 13.75, height: 14.2, width: 14.2 },
      { top: 66.1, left: 41.3, height: 14.2, width: 14.2 },
      { top: 66.1, left: 69.5, height: 14.2, width: 14.2 },
    ],
    M1: [
      { top: 45.3, left: 14.5, height: 12.5, width: 13.5 },
      { top: 45.3, left: 42, height: 12.5, width: 13.5 },
      { top: 45.3, left: 69.5, height: 12.5, width: 13.5 },
      { top: 66.8, left: 14.5, height: 13.5, width: 14.2 },
      { top: 66.8, left: 41.65, height: 13.5, width: 14.2 },
      { top: 66.8, left: 69.15, height: 13.5, width: 14.2 },
      //temperature icons
      { top: 21.47, left: 18.17, height: 14.2, width: 9.825 },
      { top: 21.47, left: 69.5, height: 14.2, width: 9.825 },
    ],
    SK: []
  },
  vdouble: {
    L9: [
      { top: 20.9, left: 12.1, height: 14.2, width: 14.2 },
      { top: 20.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 20.9, left: 68.7, height: 14.2, width: 14.2 },
      { top: 42, left: 12.1, height: 14.2, width: 14.2 },
      { top: 42, left: 40.1, height: 14.2, width: 14.2 },
      { top: 42, left: 68.7, height: 14.2, width: 14.2 },
      { top: 63.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 63.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 63.3, left: 68.7, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 16.5, left: 12.5, height: 14.2, width: 14.2 },
      { top: 16.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 16.5, left: 68.3, height: 14.2, width: 14.2 },
      { top: 33.4, left: 12.5, height: 14.2, width: 14.2 },
      { top: 33.4, left: 40.1, height: 14.2, width: 14.2 },
      { top: 33.4, left: 68.3, height: 14.2, width: 14.2 },
      { top: 50.3, left: 12.5, height: 14.2, width: 14.2 },
      { top: 50.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 50.3, left: 68.3, height: 14.2, width: 14.2 },
      { top: 67.2, left: 12.5, height: 14.2, width: 14.2 },
      { top: 67.2, left: 40.1, height: 14.2, width: 14.2 },
      { top: 67.2, left: 68.3, height: 14.2, width: 14.2 },
    ],
    M1: [
      { top: 46.57, left: 13.25, height: 12.5, width: 13.5 },
      { top: 46.57, left: 40.75, height: 12.5, width: 13.5 },
      { top: 46.57, left: 68.25, height: 12.5, width: 13.5 },
      { top: 68.1, left: 12.9, height: 13.5, width: 14.2 },
      { top: 68.1, left: 40.4, height: 13.5, width: 14.2 },
      { top: 68.1, left: 67.9, height: 13.5, width: 14.2 },
      //temperature icons
      { top: 22.7, left: 16.9, height: 14.2, width: 9.825 },
      { top: 22.7, left: 68.25, height: 14.2, width: 9.825 },
    ],
    SK: []
  },
  triple: {
    L9: [
      { top: 19.5, left: 14.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 42.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 71.2, height: 14.2, width: 14.2 },
      { top: 40.7, left: 14.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 42.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 71.2, height: 14.2, width: 14.2 },
      { top: 61.9, left: 14.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 42.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 71.2, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 15.4, left: 15, height: 14.2, width: 14.2 },
      { top: 15.4, left: 42.6, height: 14.2, width: 14.2 },
      { top: 15.4, left: 70.8, height: 14.2, width: 14.2 },
      { top: 32.3, left: 15, height: 14.2, width: 14.2 },
      { top: 32.3, left: 42.6, height: 14.2, width: 14.2 },
      { top: 32.3, left: 70.8, height: 14.2, width: 14.2 },
      { top: 49.2, left: 15, height: 14.2, width: 14.2 },
      { top: 49.2, left: 42.6, height: 14.2, width: 14.2 },
      { top: 49.2, left: 70.8, height: 14.2, width: 14.2 },
      { top: 66.1, left: 15, height: 14.2, width: 14.2 },
      { top: 66.1, left: 42.6, height: 14.2, width: 14.2 },
      { top: 66.1, left: 70.8, height: 14.2, width: 14.2 },
    ],
    SK: []
  },
  vtriple: {
    L9: [
      { top: 22.1, left: 12.1, height: 14.2, width: 14.2 },
      { top: 22.1, left: 40.1, height: 14.2, width: 14.2 },
      { top: 22.1, left: 68.7, height: 14.2, width: 14.2 },
      { top: 43.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 43.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 43.3, left: 68.7, height: 14.2, width: 14.2 },
      { top: 64.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 64.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 64.5, left: 68.7, height: 14.2, width: 14.2 },
    ],
    L12: [
      { top: 17.7, left: 12.5, height: 14.2, width: 14.2 },
      { top: 17.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 17.7, left: 68.3, height: 14.2, width: 14.2 },
      { top: 34.6, left: 12.5, height: 14.2, width: 14.2 },
      { top: 34.6, left: 40.1, height: 14.2, width: 14.2 },
      { top: 34.6, left: 68.3, height: 14.2, width: 14.2 },
      { top: 51.5, left: 12.5, height: 14.2, width: 14.2 },
      { top: 51.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 51.5, left: 68.3, height: 14.2, width: 14.2 },
      { top: 68.5, left: 12.5, height: 14.2, width: 14.2 },
      { top: 68.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 68.5, left: 68.3, height: 14.2, width: 14.2 },
    ],
    SK: []
  }

};
import isBigIconMixin from '../../../mixins/isBigIconMixin';
import { productCode } from '../../../store/storeConstants';

export default {
  name: "AriaPanel",
  mixins: [
    isBigIconMixin
  ],
  data() {
    return {
      styleMap: null
    };
  },
  methods: {
    offset(i) {
      if (i.content.hasTextL2 == false && i.iconSize == 6) {
        if (i.fontSize == 2.5) {
          return 6;
        }
        if (i.fontSize == 3.5) {
          return 5;
        }
      }

      if (i.content.hasTextL2 == true) {
        if (i.iconSize == 6) {
          if (i.fontSize == 2.5) {
            return -1;
          } else if (i.fontSize == 3.5) {
            return -4;
          }
        } else if (i.iconSize == 8 && i.fontSize == 2.5) {
          return -6;
        }

      }

      return 0;
    }
  },

  computed: {
    fontType: function () {
      return this.$store.state.artwork.fontType;
    },
    layer1: function () {
      let img = productCode.opt2[this.$store.state.artwork.format].toLowerCase() + '_' + this.$store.state.artwork.frameColor + ((this.$store.getters.isVertical) ? '_v' : '') + '.webp';
      return 'images/finishing/' + img;
    },
    layer2: function () {

      var layoutList = [];
      for (
        var i = 0;
        i < layoutMap[this.$store.state.artwork.format][this.$store.state.artwork.layout].length;
        i++
      ) {
        var lm = layoutMap[this.$store.state.artwork.format][this.$store.state.artwork.layout][i];

        var content = this.$store.state.artwork.content[i];

        if (typeof content != 'undefined') {
          var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.fontSize] + 'px';

          if (this.$store.state.artwork.layoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
            textBoxHeight = 'auto';
          } else if (this.$store.state.artwork.layoutStyle == 'iconSingleLineText' && content.textL1 == '') {
            textBoxHeight = 'auto';
          }

          layoutList.push({
            id: i,
            top: lm.top,
            left: lm.left,
            height: lm.height,
            width: lm.width,
            fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.fontSize],
            textBoxHeight: textBoxHeight,
            iconSize: this.isBigIcon(content) ? this.$store.state.bigIconSize : this.$store.state.artwork.iconSize,
            style: {
              alignment: "middle",
              constrain: this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.layout
              ][this.$store.state.artwork.layoutStyle][i] || 1,
            },
            content: content,
          });
        }
      }
      
      return layoutList;
    },

    rightLayer2: function () {
      var layoutList = [];

      for (
        var i = 0;
        i < rightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.rightLayout].length;
        i++
      ) {
        var lm = rightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.rightLayout][i];

        var content = this.$store.state.artwork.rightContent[i];
        if (typeof content != 'undefined') {
          var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.rightFontSize] + 'px';

          if (this.$store.state.artwork.rightLayoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
            textBoxHeight = 'auto';
          } else if (this.$store.state.artwork.rightLayoutStyle == 'iconSingleLineText' && content.textL1 == '') {
            textBoxHeight = 'auto';
          }

          layoutList.push({
            id: i,
            top: lm.top,
            left: lm.left,
            height: lm.height,
            width: lm.width,
            fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.rightFontSize],
            textBoxHeight: textBoxHeight,
            iconSize: this.isBigIcon(content) ? this.$store.state.bigIconSize : this.$store.state.artwork.rightIconSize,
            style: {
              alignment: "middle",
              constrain: this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.rightLayout
              ][this.$store.state.artwork.rightLayoutStyle][i] || 1,
            },
            content: content,
          });
        }
      }
      return layoutList;
    },
    tripleRightLayer2: function () {
      var layoutList = [];
      for (
        var i = 0;
        i < tripleRightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightLayout].length;
        i++
      ) {
        var lm = tripleRightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightLayout][i];

        var content = this.$store.state.artwork.tripleRightContent[i];

        if (typeof content != 'undefined') {
          var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.tripleRightFontSize] + 'px';

          if (this.$store.state.artwork.tripleRightLayoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
            textBoxHeight = 'auto';
          } else if (this.$store.state.artwork.tripleRightLayoutStyle == 'iconSingleLineText' && content.textL1 == '') {
            textBoxHeight = 'auto';
          }

          layoutList.push({
            id: i,
            top: lm.top,
            left: lm.left,
            height: lm.height,
            width: lm.width,
            fontSize: this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.tripleRightFontSize],
            textBoxHeight: textBoxHeight,
            iconSize: this.isBigIcon(content) ? this.$store.state.bigIconSize : this.$store.state.artwork.tripleRightIconSize,
            style: {
              alignment: "middle",
              constrain: this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.tripleRightLayout
              ][this.$store.state.artwork.tripleRightLayoutStyle][i] || 1,
            },
            content: content,
          });
        }
      }
      return layoutList;
    },
  },
  created() {
    this.styleMap = this.$store.state.styleMap;
  },
};
</script>

<style scoped></style>
